import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/Skeleton';
import Grid from '@material-ui/core/Grid';
import AppContainer from 'components/AppContainer';
import ClassNames from 'classnames';

const useStyles = makeStyles(() => ({
  root: {
    background: '#F8F9F9',
    height: '100vh',
  },
  container: {
    marginTop: 21,
  },
  mb12: {
    marginBottom: 12,
  },
  contentInfo: {
    background: '#fff',
    padding: '35px 25px',
    marginBottom: 30,
  },
  white: {
    background: '#fff',
  },
}));

function PageResourceSkeleton() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <AppContainer>
        <Grid item xs={12} className={classes.container}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={9}>
              <Grid item xs={12}>
                <Grid container spacing={2} className={classes.contentInfo}>
                  <Grid item xs={12} sm={3}>
                    <Skeleton variant="rect" height={200} />
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <Skeleton width={60} />
                    <Skeleton variant="rect" height={30} />
                    {Array.from(new Array(10)).map((_, index) => (
                      <Skeleton
                        variant="rect"
                        height={30}
                        className={classes.mb12}
                        key={index}
                      />
                    ))}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2} className={classes.contentInfo}>
                  <Grid item xs={12}>
                    <Skeleton width={100} />
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      {Array.from(new Array(3)).map((_, index) => (
                        <Grid item xs={4} key={index}>
                          <Skeleton variant="rect" height={348} />
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Skeleton className={ClassNames(classes.mb12, classes.white)} />
              {Array.from(new Array(4)).map((_, index) => (
                <Skeleton
                  variant="rect"
                  height={81}
                  className={ClassNames(classes.mb12, classes.white)}
                  key={index}
                />
              ))}
            </Grid>
          </Grid>
        </Grid>
      </AppContainer>
    </div>
  );
}

export default PageResourceSkeleton;
